export const latestNewsPreviewQuery = `
    {
      "newsItems": *[_type == "pressRelease" || _type == "blogArticle"] | order(publishDate desc) {
        _id,
        _type,
        i18nLang,
        publishDate,
        slug {
          current
        },
        teaserDescription,
        title
      },
      "allBlogLists": {
        "nodes": *[_type == "blogList" && slug.current != null] {
          i18nLang,
          slug {
            current
          }
        }
      },
      "allPressReleaseLists": {
        "nodes": *[_type == "pressReleaseList" && slug.current != null] {
          i18nLang,
          slug {
            current
          }
        }
      },
    }
  `;
